export type ValidationVerdict = 'COMPLAINT' | 'FALSE_POS'

export function validationVerdictFromHotkey(event: KeyboardEvent): ValidationVerdict | null {
  if (event.defaultPrevented || event.repeat || event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) {
    return null
  }

  if (isEditableTarget(event.target)) return null

  switch (event.key) {
    case '1': return 'COMPLAINT'
    case '2': return 'FALSE_POS'
    default: return null
  }
}

function isEditableTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false

  return target.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName)
}
